"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPersistentTheme = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _AsyncStorage = _interopRequireDefault(require("react-native-web/dist/cjs/exports/AsyncStorage"));

var _initialTheme = require("./initialTheme");

var THEME_STORAGE_KEY = "hova_labs_theme";
var themes = ["lightTheme", "darkTheme"];

var getPersistentTheme = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var storedTheme, fallbackTheme;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _AsyncStorage["default"].getItem(THEME_STORAGE_KEY);

          case 3:
            storedTheme = _context.sent;

            if (!(storedTheme && !themes.includes(storedTheme))) {
              _context.next = 10;
              break;
            }

            console.error("Invalid theme key");
            _context.next = 8;
            return _AsyncStorage["default"].removeItem(THEME_STORAGE_KEY);

          case 8:
            _context.next = 11;
            break;

          case 10:
            return _context.abrupt("return", storedTheme);

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            console.error("Async storage error", _context.t0);

          case 16:
            fallbackTheme = _initialTheme.isInitiallyDarkMode ? "darkTheme" : "lightTheme";
            return _context.abrupt("return", fallbackTheme);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function getPersistentTheme() {
    return _ref.apply(this, arguments);
  };
}();

exports.getPersistentTheme = getPersistentTheme;